<template>
  <div class="election-result-list cf-results">
    <!-- Section Title -->
    <header class="cf-results__head">
      <span class="cf-results__icon">
        <v-icon size="22">mdi-poll</v-icon>
      </span>
      <div class="cf-results__titles">
        <h2 class="cf-results__title">{{ title }}</h2>
        <span class="cf-results__bar" aria-hidden="true"></span>
      </div>
      <span
        class="cf-results__count"
        v-if="!LoadingFlag && Records && Records.length"
        >{{ Records.length }}
        {{ Records.length == 1 ? "Round" : "Rounds" }}</span
      >
    </header>

    <!-- Loading Animation -->
    <v-overlay
      v-if="LoadingFlag"
      absolute
      color="#ffffff"
      opacity="0.8"
      class="loading-overlay"
    >
      <v-progress-circular
        indeterminate
        width="3"
        color="#3a67b1"
      ></v-progress-circular>
    </v-overlay>

    <!-- No Results Message -->
    <div v-else-if="!Records || !Records.length" class="no-results">
      <span class="cf-empty__icon">
        <v-icon size="30">mdi-poll</v-icon>
      </span>
      <p>No election results available</p>
    </div>

    <!-- Results Grid -->
    <div v-else class="cf-rounds">
      <section
        v-for="(round, index) in Records"
        :key="index"
        class="round-card cf-round"
        :style="{ '--d': index * 90 + 'ms' }"
      >
        <!-- Round Title -->
        <header class="cf-round__head">
          <span class="cf-round__no">{{ round.RoundId }}</span>
          <h4 class="cf-round__name">{{ round.RoundName }}</h4>
          <span class="cf-round__chip">Round {{ round.RoundId }}</span>
        </header>

        <!-- Table of Members -->
        <v-data-table
          :headers="[
            { text: 'Candidate', align: 'start', value: 'MemberName' },
            {
              text: 'Photo',
              align: 'center',
              value: 'MemberImage',
              sortable: false,
            },
            { text: 'Votes', align: 'center', value: 'VoteCount' },
            { text: 'Is Eliminated', align: 'center', value: 'IsEliminated' },
          ]"
          :items="round.VoteData"
          :items-per-page="10"
          class="elevation-0 cf-table"
        >
          <!-- Member Name -->
          <template #[`item.MemberName`]="{ item }">
            <span class="cf-table__name">{{ item.MemberName }}</span>
          </template>

          <!-- Member Photo -->
          <template #[`item.MemberImage`]="{ item }">
            <div class="d-flex justify-center">
              <v-avatar size="42" class="cf-table__avatar">
                <v-img
                  :src="item.MemberImage"
                  :alt="item.MemberName"
                  @error="handleImageError"
                >
                  <template v-slot:placeholder>
                    <v-avatar color="#3a67b1" size="42">
                      <span class="cf-table__initials">{{
                        getInitials(item.MemberName)
                      }}</span>
                    </v-avatar>
                  </template>
                </v-img>
              </v-avatar>
            </div>
          </template>

          <!-- Vote Count -->
          <template #[`item.VoteCount`]="{ item }">
            <span
              class="cf-votes"
              :class="item.IsEliminated ? 'cf-votes--out' : 'cf-votes--in'"
            >
              {{ item.VoteCount }}
            </span>
          </template>

          <!-- Status -->
          <template #[`item.IsEliminated`]="{ item }">
            <span
              class="cf-status"
              :class="item.IsEliminated ? 'cf-status--out' : 'cf-status--in'"
            >
              <span class="cf-status__dot" aria-hidden="true"></span>
              {{ item.IsEliminated }}
            </span>
          </template>
        </v-data-table>
      </section>
    </div>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";

export default {
  name: "ElectionResultList",
  mixins: [common],
  props: {
    conference: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    designation: {
      type: Number,
      required: true,
    },
    type: {
      type: Number,
      required: true,
    },
    zone: {
      type: [Number, String],
      required: false,
      default: "",
    },
  },
  data() {
    return {
      Records: [],
      LoadingFlag: false,
      defaultAvatarUrl: "/media/users/default.jpg",
    };
  },
  methods: {
    getInitials(name) {
      return name
        .split(" ")
        .map((word) => word[0])
        .join("")
        .toUpperCase()
        .substr(0, 2);
    },
    handleImageError(error) {
      if (error && error.target) {
        error.target.src = this.defaultAvatarUrl;
      }
    },
    getElectionResultRecords() {
      console.log("getTableRecords called");

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/nomination-vote/round-results";
      var upload = {
        UserInterface: 1,
        NominationDesignation: this.designation,
        Conference: this.conference,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var records = "";
      var flag = 0;

      this.Records = [];
      this.ResultFlag = false;
      this.LoadingFlag = true;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.ResultFlag = true;
          thisIns.LoadingFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          output = response.data.output;
          records = response.data.records;
          console.log("output=" + output + ", flag=" + flag);
    
          var options = records.TableOptions;
          thisIns.tableOptions1 = options;

          if (flag == 1) {
            thisIns.Records = records;
            
            thisIns.toast("success", output);
          } else {
            thisIns.toast("error", output);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.toast("error", error);
          thisIns.ResultFlag = true;
          thisIns.LoadingFlag = false;
        });
    },

  },
  created() {
    this.getElectionResultRecords();
  },
  watch: {
    conference() {
      this.getElectionResultRecords();
    },
    designation() {
      this.getElectionResultRecords();
    },
    zone() {
      this.getElectionResultRecords();
    },
  },
};
</script>

<style lang="scss" scoped>
/* JCI approved palette */
.cf-results {
  --navy: #3a67b1;
  --aqua: #0097d7;
  --gold: #edbe38;
  --seafoam: #56bda3;
  --ink: #0a0f29;
  --text: #414042;
  --danger: #c53030;
  --muted: #6b7280;
  --line: #e3e9f3;
  --line-strong: #cdd8ea;
  --surface-tint: #f5f7fc;
  --ease: cubic-bezier(0.22, 0.61, 0.36, 1);
  --ease-out: cubic-bezier(0.16, 1, 0.3, 1);

  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 220px;
  color: var(--text);
  font-family: "Poppins", "Roboto", sans-serif;
}

/* ---------- Header (coloured band, JCI approved colours) ---------- */
.cf-results__head {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  margin-bottom: 14px;
  border-radius: 16px;
  color: #ffffff;
  background: linear-gradient(120deg, var(--seafoam), var(--aqua));
  box-shadow: 0 12px 24px -16px rgba(10, 15, 41, 0.6);

  &::after {
    /* fine grid texture */
    content: "";
    position: absolute;
    inset: 0;
    background-image: linear-gradient(
        rgba(255, 255, 255, 0.08) 1px,
        transparent 1px
      ),
      linear-gradient(90deg, rgba(255, 255, 255, 0.08) 1px, transparent 1px);
    background-size: 22px 22px;
    mask-image: linear-gradient(90deg, transparent 30%, #000 95%);
    -webkit-mask-image: linear-gradient(90deg, transparent 30%, #000 95%);
    pointer-events: none;
  }
}
.cf-results__icon {
  position: relative;
  z-index: 1;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.32);
  transition: transform 280ms var(--ease);

  .v-icon {
    color: #ffffff !important;
  }
}
.cf-results:hover .cf-results__icon {
  transform: rotate(-6deg) scale(1.05);
}
.cf-results__titles {
  position: relative;
  z-index: 1;
  flex: 1 1 auto;
  min-width: 0;
}
.cf-results__title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  line-height: 1.3;
  color: #ffffff;
  overflow-wrap: anywhere;
}
.cf-results__bar {
  display: block;
  width: 36px;
  height: 3px;
  margin-top: 6px;
  border-radius: 3px;
  background: #ffffff;
  opacity: 0.75;
  transform-origin: left center;
  animation: cf-grow 700ms var(--ease-out) 150ms backwards;
}
.cf-results__count {
  position: relative;
  z-index: 1;
  flex: 0 0 auto;
  padding: 5px 12px;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--ink);
  background: #ffffff;
  box-shadow: 0 6px 14px -8px rgba(10, 15, 41, 0.6);
  white-space: nowrap;
}

/* ---------- Loading & empty ---------- */
.loading-overlay {
  border-radius: 16px;
}
.no-results {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 28px 16px;
  text-align: center;
  border: 1.5px dashed var(--line-strong);
  border-radius: 16px;
  background: var(--surface-tint);
  animation: cf-fade 500ms var(--ease-out);

  p {
    margin: 12px 0 0;
    font-size: 0.88rem;
    font-weight: 500;
    color: var(--muted);
  }
}
.cf-empty__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #ffffff;
  border: 1px solid var(--line);
  box-shadow: 0 10px 24px -14px rgba(58, 103, 177, 0.6);

  .v-icon {
    color: var(--seafoam) !important;
  }
}

/* ---------- Rounds ---------- */
.cf-rounds {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 520px;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding-right: 4px;
  scrollbar-width: thin;
  scrollbar-color: rgba(58, 103, 177, 0.3) transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(58, 103, 177, 0.3);
    border-radius: 3px;
  }
}
.cf-round {
  position: relative;
  padding: 14px;
  border-radius: 18px;
  background: linear-gradient(180deg, var(--surface-tint), #ffffff 70%);
  border: 1px solid var(--line);
  animation: cf-fade 520ms var(--ease-out) backwards;
  animation-delay: var(--d, 0ms);
  transition: box-shadow 280ms var(--ease), border-color 280ms var(--ease);

  &:hover {
    border-color: var(--line-strong);
    box-shadow: 0 14px 28px -18px rgba(58, 103, 177, 0.55);
  }
}
.cf-round__head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
.cf-round__no {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  font-size: 0.92rem;
  font-weight: 700;
  color: #ffffff;
  background: linear-gradient(135deg, var(--navy), var(--aqua));
  box-shadow: 0 8px 16px -10px rgba(58, 103, 177, 0.9);
}
.cf-round__name {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
  font-size: 0.98rem;
  font-weight: 700;
  color: var(--ink);
  overflow-wrap: anywhere;
}
.cf-round__chip {
  flex: 0 0 auto;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--navy);
  background: rgba(58, 103, 177, 0.1);
}

/* ---------- Premium data table ---------- */
.cf-table.v-data-table {
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid var(--line);
  background: #ffffff;
  font-family: inherit;

  ::v-deep .v-data-table__wrapper {
    overflow-x: auto;
  }
  ::v-deep .v-data-table__wrapper > table > thead > tr > th {
    height: 42px;
    padding: 0 14px;
    background: var(--surface-tint);
    border-bottom: 1px solid var(--line-strong) !important;
    color: var(--ink) !important;
    font-size: 0.74rem !important;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    white-space: nowrap;
  }
  ::v-deep .v-data-table__wrapper > table > thead > tr > th.active,
  ::v-deep .v-data-table__wrapper > table > thead > tr > th:hover {
    color: var(--navy) !important;
  }
  ::v-deep .v-data-table__wrapper > table > tbody > tr > td {
    height: 56px;
    padding: 6px 14px;
    font-size: 0.88rem !important;
    color: var(--text);
    border-bottom: 1px solid var(--line) !important;
  }
  ::v-deep .v-data-table__wrapper > table > tbody > tr:last-child > td {
    border-bottom: 0 !important;
  }
  ::v-deep
    .v-data-table__wrapper
    > table
    > tbody
    > tr:hover:not(.v-data-table__expanded__content):not(
      .v-data-table__empty-wrapper
    ) {
    background: rgba(58, 103, 177, 0.05) !important;
  }
  ::v-deep .v-data-footer {
    padding: 4px 8px;
    border-top: 1px solid var(--line) !important;
    font-size: 0.8rem;
    color: var(--muted);
  }
  ::v-deep .v-data-footer .v-btn:not(.v-btn--disabled) .v-icon {
    color: var(--navy);
  }
  ::v-deep .v-data-table__mobile-row {
    min-height: 44px;
  }
  ::v-deep .v-data-table__mobile-row__header {
    font-size: 0.74rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: var(--muted);
  }
  ::v-deep .v-data-table__mobile-table-row > td:last-child {
    border-bottom: 1px solid var(--line-strong) !important;
  }
}

.cf-table__name {
  font-weight: 600;
  color: var(--ink);
}
.cf-table__avatar {
  border: 2px solid #ffffff;
  box-shadow: 0 0 0 2px rgba(58, 103, 177, 0.25);
}
.cf-table__initials {
  font-size: 0.85rem;
  font-weight: 700;
  color: #ffffff;
}
.cf-votes {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 46px;
  height: 30px;
  padding: 0 12px;
  border-radius: 10px;
  font-size: 0.95rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}
.cf-votes--in {
  color: #ffffff;
  background: linear-gradient(135deg, var(--seafoam), #3d9c84);
  box-shadow: 0 8px 16px -10px rgba(86, 189, 163, 0.9);
}
.cf-votes--out {
  color: #4b5563;
  background: #eef0f4;
}
.cf-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 600;
  border: 1px solid transparent;
}
.cf-status__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
}
.cf-status--out {
  color: #a32626;
  background: rgba(197, 48, 48, 0.08);
  border-color: rgba(197, 48, 48, 0.3);
}
.cf-status--in {
  color: #2f7d69;
  background: rgba(86, 189, 163, 0.14);
  border-color: rgba(86, 189, 163, 0.45);
}

@media (max-width: 599px) {
  .cf-round {
    padding: 10px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .cf-results *,
  .cf-results *::before {
    animation: none !important;
    transition: none !important;
  }
}

@keyframes cf-grow {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}
@keyframes cf-fade {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
</style>
